
import { Prop, Component, Vue } from 'nuxt-property-decorator';

@Component({
  components: {},
})
export default class LandingSocialGrid extends Vue {
  onTrackNavigation(url: string) {
    this.$ua.trackNavigationEvent({
      to: url,
      from: this.$route.fullPath,
    });
  }
}
